/* Product page help (snippets/aura-product-help.liquid).
   1. Sizes and colours that cannot be bought with the current choice get .is-soldout (visual only: theme.js still decides
      what is clickable, the first option stays clickable so no variant becomes unreachable).
   2. When the chosen combination is sold out or does not exist, a hint lists what IS in stock as buttons. A button picks
      that value through the normal option button, so the change is visible and announced - never a silent swap. */
(function () {
  'use strict';

  function setup(script) {
    var root = script.closest('form') || script.parentElement;
    if (!root || root.hasAttribute('data-aura-help-ready')) return;
    var variants;
    try { variants = JSON.parse(script.textContent); } catch (error) { return; }
    var groups = Array.prototype.slice.call(root.querySelectorAll('.product-option'));
    if (!groups.length || !Array.isArray(variants)) return;
    root.setAttribute('data-aura-help-ready', '');

    var texts = document.querySelector('[data-aura-avail-texts]');
    var textUnavailable = texts ? texts.getAttribute('data-unavailable') : '';
    var textInStock = texts ? texts.getAttribute('data-instock') : '';
    var hint = document.createElement('div');
    hint.className = 'aura-avail';
    hint.hidden = true;
    hint.setAttribute('role', 'status');
    (root.querySelector('[data-product-options]') || groups[groups.length - 1].parentElement).appendChild(hint);

    function indexOf(group) { return Number(group.getAttribute('data-option-index')); }

    function selected() {
      var values = [];
      groups.forEach(function (group) {
        var button = group.querySelector('[data-option-value].is-selected');
        var select = group.querySelector('select.option-dropdown');
        values[indexOf(group)] = button ? button.getAttribute('data-option-value') : select ? select.value : undefined;
      });
      return values;
    }

    function fits(variant, values, skip) {
      return variant.options.every(function (value, i) { return i === skip || values[i] === undefined || value === values[i]; });
    }
    function inStockWith(index, value, values) {
      return variants.some(function (v) { return v.available && v.options[index] === value && fits(v, values, index); });
    }
    function inStockAnywhere(index, value) {
      return variants.some(function (v) { return v.available && v.options[index] === value; });
    }
    function valuesOf(group) {
      var buttons = group.querySelectorAll('[data-option-value]');
      if (buttons.length) return Array.prototype.map.call(buttons, function (b) { return b.getAttribute('data-option-value'); });
      return Array.prototype.map.call(group.querySelectorAll('select.option-dropdown option'), function (o) { return o.value; });
    }

    function pick(group, value) {
      var button = Array.prototype.find.call(group.querySelectorAll('[data-option-value]'), function (b) { return b.getAttribute('data-option-value') === value; });
      if (button) { button.click(); return; }
      var select = group.querySelector('select.option-dropdown');
      if (select) { select.value = value; select.dispatchEvent(new Event('change', { bubbles: true })); }
    }

    function render(values, variant) {
      hint.textContent = '';
      if (variant && variant.available) { hint.hidden = true; return; }
      // Alternatives that change one option only; if none exist, everything still in stock for each option.
      var choices = groups.map(function (group) {
        var index = indexOf(group);
        return { group: group, values: valuesOf(group).filter(function (value) { return value !== values[index] && inStockWith(index, value, values); }) };
      }).filter(function (entry) { return entry.values.length; });
      if (!choices.length) {
        choices = groups.map(function (group) {
          var index = indexOf(group);
          return { group: group, values: valuesOf(group).filter(function (value) { return value !== values[index] && inStockAnywhere(index, value); }) };
        }).filter(function (entry) { return entry.values.length; });
      }
      if (!choices.length) { hint.hidden = true; return; }
      if (variant && textUnavailable) {
        var title = document.createElement('p');
        title.className = 'aura-avail__title';
        title.textContent = textUnavailable;
        hint.appendChild(title);
      }
      var line = document.createElement('p');
      line.className = 'aura-avail__choices';
      var lead = document.createElement('span');
      lead.textContent = textInStock;
      line.appendChild(lead);
      choices.forEach(function (entry) {
        var name = document.createElement('span');
        name.className = 'aura-avail__group';
        name.textContent = entry.group.getAttribute('data-option-name');
        line.appendChild(name);
        entry.values.forEach(function (value) {
          var chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'aura-avail__chip';
          chip.textContent = value;
          chip.addEventListener('click', function () { pick(entry.group, value); });
          line.appendChild(chip);
        });
      });
      hint.appendChild(line);
      hint.hidden = false;
    }

    function update() {
      var values = selected();
      groups.forEach(function (group) {
        var index = indexOf(group);
        group.querySelectorAll('[data-option-value]').forEach(function (button) {
          var value = button.getAttribute('data-option-value');
          button.classList.toggle('is-soldout', !inStockWith(index, value, values));
        });
      });
      var variant = variants.find(function (v) { return v.options.every(function (value, i) { return value === values[i]; }); }) || null;
      render(values, variant);
    }

    // theme.js announces the change on its own root (an ancestor of the form), so listen where it bubbles to.
    document.addEventListener('aura:variant-change', function (event) {
      if (event.target === root || (event.target.contains && event.target.contains(root)) || root.contains(event.target)) setTimeout(update, 0);
    });
    update();
  }

  function init() {
    document.querySelectorAll('[data-product-variants]').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
